import { useInterfaceLanguage } from '@/shared/i18n';
import { formatInterfaceNumber } from '@/shared/i18n/formatLocale';

import {
  AmazonIcon,
  Container,
  FameplayIcon,
  MengmiuIcon,
  PartnersIconsContainer,
  PartnersTitle,
  PublicisIcon,
  SemrushIcon,
} from './styled';

export type PartnersProps = {
  backgroundColor?: string;
  isSmallFromTablet?: boolean;
};

export const Partners = ({ backgroundColor, isSmallFromTablet = false }: PartnersProps) => {
  const { locale, t } = useInterfaceLanguage();

  return (
    <Container backgroundColor={backgroundColor} isSmallFromTablet={isSmallFromTablet}>
      <PartnersTitle isSmallFromTablet={isSmallFromTablet}>
        {t('pricing.socialProof', { count: formatInterfaceNumber(locale, 3_400_000) })}
      </PartnersTitle>
      <PartnersIconsContainer isSmallFromTablet={isSmallFromTablet}>
        <FameplayIcon isSmallFromTablet={isSmallFromTablet} />
        <AmazonIcon isSmallFromTablet={isSmallFromTablet} />
        <SemrushIcon isSmallFromTablet={isSmallFromTablet} />
        <MengmiuIcon isSmallFromTablet={isSmallFromTablet} />
        <PublicisIcon isSmallFromTablet={isSmallFromTablet} />
      </PartnersIconsContainer>
    </Container>
  );
};
